if (!customElements.get('early-access-bar')) {
  class EarlyAccessBar extends HTMLElement {
    static ROTATE_INTERVAL = 4000;

    #activeIndex = 0;
    #rotateTimer = null;
    #resizeObserver = null;
    #mobileQuery = window.matchMedia('(max-width: 749px)');

    connectedCallback() {
      this.cacheElements();
      this.#activeIndex = Math.max(0, this.slides.length - 1);
      this.setTopBarHeight = this.setTopBarHeight.bind(this);
      this.syncRotation = this.syncRotation.bind(this);

      this.setTopBarHeight();
      if (window.ResizeObserver) {
        this.#resizeObserver = new ResizeObserver(this.setTopBarHeight);
        this.#resizeObserver.observe(this);
      } else {
        window.addEventListener('resize', this.setTopBarHeight);
      }

      this.syncRotation();
      this.#mobileQuery.addEventListener('change', this.syncRotation);
    }

    disconnectedCallback() {
      this.stopRotation();
      this.#mobileQuery.removeEventListener('change', this.syncRotation);
      window.removeEventListener('resize', this.setTopBarHeight);
      if (this.#resizeObserver) this.#resizeObserver.disconnect();
      document.documentElement.style.removeProperty('--top-bar-height');
    }

    cacheElements() {
      this.slides = Array.from(this.querySelectorAll('[data-ea-bar-slide]'));
    }

    setTopBarHeight() {
      document.documentElement.style.setProperty('--top-bar-height', `${this.offsetHeight}px`);
    }

    syncRotation() {
      if (this.#mobileQuery.matches && this.slides.length > 1) {
        this.startRotation();
      } else {
        this.stopRotation();
      }
    }

    startRotation() {
      if (this.#rotateTimer) return;
      this.setAttribute('data-rotating', '');
      this.showSlide(this.#activeIndex);
      this.#rotateTimer = setInterval(() => {
        this.#activeIndex = (this.#activeIndex + 1) % this.slides.length;
        this.showSlide(this.#activeIndex);
      }, EarlyAccessBar.ROTATE_INTERVAL);
    }

    stopRotation() {
      if (this.#rotateTimer) {
        clearInterval(this.#rotateTimer);
        this.#rotateTimer = null;
      }
      this.removeAttribute('data-rotating');
      this.slides.forEach((slide) => slide.classList.remove('is-active'));
    }

    showSlide(index) {
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    }
  }

  customElements.define('early-access-bar', EarlyAccessBar);
}
